import { isMoment } from 'moment';

export const REQUIRED = 'Это обязательное поле для заполнения';
export const WRONG_PIN = 'Неверный пароль';
export const INVALID_DATE_RANGE = 'Поле должно содержать дату не ранее';
export default Object.freeze({
  1: {
    message:
      'Допускаются только буквы латинского алфавита, цифры, точки, запятые, пробелы, тире, круглые скобки, слеши (/)',
    regExp: /^[\w\s\(\)\/.,-]+$/,
  },
  2: {
    message: 'Допускаются только цифры и буквы латинского алфавита',
    regExp: /^\w+$/,
  },
  3: {
    message: 'Поле должно содержать дату в формате ДД.ММ.ГГГГ',
    regExp: /\d{2}([./-])\d{2}([./-])\d{4}$/,
  },
});

export function Validate(val, configObj) {
  const {
    props: { isRequired, minLength, maxLength },
  } = configObj;
  const value = isMoment(val) ? val.defaultFormat() : val;
  let regExp, message;
  let isValid = false;
  if (configObj.validationObject) {
    regExp = configObj.validationObject.regExp;
    message = configObj.validationObject.message;
  }
  if (!isRequired && !value) {
    return { isValid: true, validationMessage: '' };
  }
  let { isInValid, validationMessage } = isRequiredValidation(isRequired, value);
  if (isInValid) {
    return { isValid: false, validationMessage };
  } else {
    if (minLength && value.length < minLength) {
      validationMessage = `минимальная длина ${minLength}`;
      return { isValid, validationMessage };
    }
    if (maxLength && value.length > maxLength) {
      validationMessage = `максимальная длина ${maxLength}`;
      return { isValid, validationMessage };
    }
    if (regExp && value.match(regExp) === null) {
      validationMessage = message;
      return { isValid, validationMessage };
    } else {
      return { isValid: true, validationMessage: '' };
    }
  }
}

function isRequiredValidation(isRequired, value) {
  return isRequired && !value
    ? { isInValid: true, validationMessage: REQUIRED }
    : {
        isInValid: false,
        validationMessage: '',
      };
}
